import moment, { Moment } from 'moment'

export const setUTCTimezone = (date: Date | string) =>
    moment(date).utc().toDate()

export const utlToLocal = (currentDate: Moment, time: string) => {
    const date = currentDate.format('YYYY-MM-DD')
    return moment.utc(`${date} ${time}`, 'YYYY-MM-DD HH:mm').local()
}

export const convertToUTC = (time: string) =>
    moment(time, 'HH:mm').utc().format('HH:mm:ss.SSS[Z]')
